var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KPage',[_c('CollectionView',{attrs:{"collection":_vm.collect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }